export class WinningChances {
    WinningChanceID: number;
    ChancePercentage: number;
    IsActive: boolean = true;
    ModifiedBy: number;
}